import {
  ContentLocation,
  ContentLocationGetter,
  PopoverState,
} from 'react-tiny-popover';

export const SEARCH_MODAL_POPOVER_VIEWPORT_INSET = 16;

type ViewportSize = {
  width: number;
  height: number;
};

export const resolveViewportConstrainedPopoverLocation = (
  {
    childRect,
    popoverRect,
    parentRect,
    padding,
  }: Pick<PopoverState, 'childRect' | 'popoverRect' | 'parentRect' | 'padding'>,
  viewport: ViewportSize
): ContentLocation => {
  const desiredTop = childRect.bottom + padding;
  const maximumTop =
    viewport.height - popoverRect.height - SEARCH_MODAL_POPOVER_VIEWPORT_INSET;
  const viewportTop = Math.max(
    SEARCH_MODAL_POPOVER_VIEWPORT_INSET,
    Math.min(desiredTop, maximumTop)
  );

  const desiredLeft = childRect.left;
  const maximumLeft =
    viewport.width - popoverRect.width - SEARCH_MODAL_POPOVER_VIEWPORT_INSET;
  const viewportLeft = Math.max(
    SEARCH_MODAL_POPOVER_VIEWPORT_INSET,
    Math.min(desiredLeft, maximumLeft)
  );

  return {
    top: viewportTop - parentRect.top,
    left: viewportLeft - parentRect.left,
  };
};

export const getViewportConstrainedPopoverLocation: ContentLocationGetter = (
  popoverState
) =>
  resolveViewportConstrainedPopoverLocation(popoverState, {
    width: window.innerWidth,
    height: window.innerHeight,
  });
